export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    minWidth: '480px',
    padding: '24px',
    backgroundColor: '#FFFFFF',
    fontFamily: '"Proxima Nova", sans-serif',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '24px',
  },
  logo: {
    height: '28px',
    width: 'auto',
  },
  logoText: {
    color: '#EE4360',
    fontSize: '30px',
    fontWeight: 800,
    lineHeight: '40px',
    margin: 0,
  },
  heading: {
    color: '#2E3860',
    textAlign: 'center',
    fontSize: '32px',
    fontWeight: 800,
    lineHeight: '40px',
    margin: '0 0 24px 0',
    maxWidth: '500px',
  },
  subtext: {
    color: '#626379',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    margin: '0 0 24px 0',
    maxWidth: '450px',
  },
  supportLink: {
    color: '#626379',
    textDecoration: 'none',
  },
}
